<fury-page>
    <fury-title class="title">
      <span [@fadeInRight]>{{reviewId ? 'Update' : 'Add New'}} User Review</span>
    </fury-title>
  </fury-page>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div [@fadeInUp] class="card">
        <form [formGroup]="userForm" style="width: 100%;">
          <div class="content" fxLayout="column" fxLayoutGap="8px">
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>User Name</mat-label>
              <input matInput placeholder="User Name"  formControlName="userName">
              <mat-error *ngIf="userForm.controls['userName'].touched && userForm.controls['userName'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Review From</mat-label>
              <mat-select formControlName="reviewFrom">
                <mat-option value="Yelp">Yelp</mat-option>
                <mat-option value="Google">Google</mat-option>
                <mat-option value="Trust Pilot">Trust Pilot</mat-option>
                <mat-option value="Best Company">Best Company</mat-option>
                <mat-option value="Home Advisor">Home Advisor</mat-option>
                <mat-option value="Consumer Affairs">Consumer Affairs</mat-option>
                <mat-option value="Home Warranty Reviews">Home Warranty Reviews</mat-option>
                <mat-option value="Better Business Bureau">Better Business Bureau</mat-option>
              </mat-select>
              <mat-error *ngIf="userForm.controls['reviewFrom'].touched && userForm.controls['reviewFrom'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Rating</mat-label>
              <input type="number" matInput placeholder="Rating" formControlName="rating" min="0" max="5">
              <mat-error *ngIf="userForm.controls['rating'].touched && userForm.controls['rating'].hasError('required')">
                This is a required field.</mat-error>
                <mat-error *ngIf="userForm.controls['rating'].touched && userForm.controls['rating'].hasError('min')">
                  Minimum value should be 0.</mat-error>
                  <mat-error *ngIf="userForm.controls['rating'].touched && userForm.controls['rating'].hasError('max')">
                    Maximum value should be 5.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>User Location</mat-label>
              <input matInput placeholder="User Location" formControlName="userLocation">
              <mat-error *ngIf="userForm.controls['userLocation'].touched && userForm.controls['userLocation'].hasError('required')">
                  This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Review Text</mat-label>
              <textarea type="text" matInput placeholder="Review Text" formControlName="reviewText"> </textarea>
              <mat-error *ngIf="userForm.controls['reviewText'].touched && userForm.controls['reviewText'].hasError('required')">
                  This is a required field.</mat-error>
            </mat-form-field>
          </div>
          <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          
            <button mat-button type="button" class="sub-button" (click)="addReview()">{{reviewId ? 'Update' : 'Add'}}</button>
            <button class="can-button" (click)="this.location.back()" mat-button>Cancel</button>
          </div>
            
            
          </form>
    </div>
  </div>
  

